import { getConnectorAnchors } from '../coords';
/** Add a wide invisible stroke so connectors receive pointer events. */
export function attachEdgeHitTarget(app, edge) {
    var _a, _b, _c, _d, _e;
    if ((_a = edge.metadata) === null || _a === void 0 ? void 0 : _a.edgeHitAttached)
        return;
    var poly = edge.children.find(function (c) { var _a; return c.type === 'polyline' && ((_a = c.metadata) === null || _a === void 0 ? void 0 : _a.edgeHitPolyline) !== true; });
    var fromPoly = poly && 'points' in poly ? ((_b = poly.points) !== null && _b !== void 0 ? _b : []) : [];
    var fromMeta = (_d = (_c = edge.metadata) === null || _c === void 0 ? void 0 : _c.edgePoints) !== null && _d !== void 0 ? _d : [];
    var points = fromPoly.length >= 4 ? fromPoly : fromMeta;
    if (points.length < 4)
        return;
    var hit = app.polyline({
        points: points.slice(),
        fill: null,
        stroke: 'rgba(0,0,0,0.001)',
        strokeWidth: 18,
        lineJoin: 'round',
        lineCap: 'round',
        listening: true,
    });
    hit.metadata.edgeHitPolyline = true;
    edge.add(hit);
    edge.listening = true;
    // Parent edge layer is created with listening:false so wires don't steal node
    // hits by default — enable it once edges need pointer events.
    var layer = edge.parent;
    if ((_e = layer === null || layer === void 0 ? void 0 : layer.metadata) === null || _e === void 0 ? void 0 : _e.diagramEdgeLayer)
        layer.listening = true;
    edge.metadata.edgeHitAttached = true;
}
export function edgeAnchorPoint(root, from, to, end) {
    var anchors = getConnectorAnchors(from, to, root);
    if (end === 'from')
        return { x: root.x + anchors.x1, y: root.y + anchors.y1 };
    return { x: root.x + anchors.x2, y: root.y + anchors.y2 };
}
